module.exports = require("@modelcontextprotocol/sdk/types.js");